import { render, staticRenderFns } from "./edit-summary.vue?vue&type=template&id=c96c6372&scoped=true&"
import script from "./edit-summary.vue?vue&type=script&lang=js&"
export * from "./edit-summary.vue?vue&type=script&lang=js&"
import style0 from "./edit-summary.vue?vue&type=style&index=0&id=c96c6372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c6372",
  null
  
)

export default component.exports